<script setup lang="ts">
const domainsArray = defineModel()

const {data: domains} = await useApi('/domain', {
  transform: (res) => {
    return res.data.map(function (a) {
      //a.icon = getIcon(a.slug)
      a.label = a.name
      a.icon = null
      return a
    });
  },
});
</script>

<template>
  <UPopover>
    <UButton :variant="domainsArray.length ? 'solid' : 'soft'" label="Domaine de l'association" size="sm" :class="['rounded-full',  domainsArray.length ? '' : 'font-normal']" trailing-icon="i-ph:caret-down">
      <template #default>
        <span v-if="!domainsArray.length">Domaine de l'association</span>
        <span v-else>{{domainsArray.length === 1 ? domains.find((i) => i.slug == domainsArray[0]).name : `${domainsArray.length} domaines sélectionnés` }}</span>
      </template>
      <template v-if="domainsArray.length" #trailing>
        <UIcon name="ph-x" tabindex="-1" @click="domainsArray = []" class="i-ph:x shrink-0 size-4" />
      </template>
    </UButton>

    <template #content>
      <UListbox v-model="domainsArray" :items="domains" value-key="slug" multiple class="ring-0" />
    </template>
  </UPopover>
</template>